module.exports = __webpack_public_path__ + "bin/18b0921faf7bba506f84ad1918898432.jpeg";